import { useState } from 'react'
import styled from 'styled-components'
import useMobile from '../../../other/Hooks/useMobile'
import Theme from '../../../Theme'

type Props = {
    skipToTimeStamp: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
    watched: boolean
    position: string
    chapter: string
}

const Hover = styled.div<{ left: string }>`
    display:flex;
    flex-direction:column;
    align-items:center;
    bottom:0;
    position:absolute;
    left:${({ left }) => left};
    transform:translateX(-45%);
`

const Chapter = styled.div`
    background-color:${Theme.colors.BrandOrange};
    text-align:center;
    color:${Theme.colors.White};
    width:200px;
    padding:10px;
    font-size:14px;
    font-weight:bold;
    line-height:20px;
`

const Line = styled.div`
    width:2px;
    height:37px;
    background-color:white;
`

export default function TimeStamp({ watched, skipToTimeStamp, position, chapter }: Props) {
    const [hover, setHover] = useState(false)
    const isMobile = useMobile()
    return (
        <>
            {hover &&
                <Hover left={position}>
                    <Chapter>{chapter}</Chapter>
                    <Line />
                </Hover>
            }
            <div onClick={skipToTimeStamp} style={{ position: "absolute", top: "-7px", left: position }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}>
                    <circle cx="9.5" cy="9.5" r="7" fill="#ED8B00" stroke={watched ? "#ED8B00" : "white"} strokeWidth={isMobile ? "2.5" : "5"} />
                </svg>
            </div>
        </>
    )
}
